export default "__VITE_ASSET__fDPu8Frn__"